<template>
  <div>
    <div :class="'elfsight-app-' + elfsightKey">
      <div class="d-flex justify-center py-10">
        <v-progress-circular :size="50" color="primary" indeterminate />
      </div>
    </div>
  </div>
</template>

<script>
function timeoutRemoveLink() {
  const el = document.querySelector(".eapps-instagram-feed > a");

  if (el) {
    el.remove();
  } else {
    setTimeout(timeoutRemoveLink, 500);
  }
}

export default {
  props: {
    elfsightKey: {
      type: String,
      required: true,
    },
  },
  methods: {
    render() {
      let script = document.getElementById("elfsight-key-" + this.elfsightKey);
      if (script) script.remove();

      script = document.createElement("script");
      script.id = "elfsight-key-" + this.elfsightKey;
      script.src = "https://static.elfsight.com/platform/platform.js";

      document.head.insertAdjacentElement("beforeend", script);

      timeoutRemoveLink();
    },
  },
  watch: {
    elfsightKey() {
      this.render();
    },
  },
  mounted() {
    if (this.elfsightKey) this.render();
  },
};
</script>
